import { useApolloClient, useLazyQuery, gql } from '@apollo/client';
import { EventNotification } from '@bechtel/types';
import { forEach } from 'lodash';
import { GET_EVENT_NOTIFICATIONS_BY_IDS } from '@bechtel/client-gql';

export function useEventNotificationsCache() {
  const client = useApolloClient();
  const [loadUpdatedEventNotifications] = useLazyQuery<
    {
      eventNotificationsByIds: EventNotification[];
    },
    {
      ids: string[];
    }
  >(GET_EVENT_NOTIFICATIONS_BY_IDS, { fetchPolicy: 'network-only' });

  const updateEventNotificationsCache = (ids: string[]) => {
    if (!ids || ids.length == 0) return;
    const cachedEventNotificationIds: string[] = [];
    forEach(ids, (eventId) => {
      const cachedEventNotification = client.readFragment({
        id: `EventNotification:${eventId}`,
        fragment: gql`
          fragment en on EventNotification {
            id
          }
        `,
      });
      if (cachedEventNotification) cachedEventNotificationIds.push(eventId);
    });
    if (cachedEventNotificationIds.length == 0) return;

    loadUpdatedEventNotifications({
      variables: {
        ids: cachedEventNotificationIds,
      },
    });
  };
  return { updateEventNotificationsCache };
}
